import { render, staticRenderFns } from "./Datalist.vue?vue&type=template&id=79cbc93b&scoped=true&"
import script from "./Datalist.vue?vue&type=script&lang=js&"
export * from "./Datalist.vue?vue&type=script&lang=js&"
import style0 from "./Datalist.vue?vue&type=style&index=0&id=79cbc93b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cbc93b",
  null
  
)

export default component.exports